export function addEvent(eventType, marker, handler) {
    if (eventType && marker && handler) {
        var options = marker.getOptions();
        var html = options.htmlContent;
        var elm = html;

        if (typeof html === 'string') {
            elm = document.createElement('div');
            elm.innerHTML = html.replace(/{color}/g, options.color || "")
                .replace(/{text}/g, options.text || "");
            marker.setOptions({ htmlContent: elm });
        }

        elm.style.cursor = 'pointer';

        elm['on' + eventType] = function () {
            handler(eventType, marker);
        };
    }
}